var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 16.6663C15.6667 14.7027 13.2789 13.1108 10.3333 13.1108C7.38781 13.1108 5 14.7027 5 16.6663M10.3333 10.4441C8.36965 10.4441 6.77778 8.85224 6.77778 6.88856C6.77778 4.92488 8.36965 3.33301 10.3333 3.33301C12.297 3.33301 13.8889 4.92488 13.8889 6.88856C13.8889 8.85224 12.297 10.4441 10.3333 10.4441Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.12c1d97f5f4a56b8cae19cd7df63660f.svg";
export { ForwardRef as ReactComponent };